import {GenericMetaData} from './generic-meta-data';

export interface MetaDataInterface extends GenericMetaData {
  name: string;
  status: string;
  message: string;
  source: string;
  quantity: string;
  dateTime: any;
}

export class OsrMetaData implements MetaDataInterface {

  name: string;
  status: string;
  message: string;
  source: string;
  quantity: string;
  dateTime: string;
  time: string;

  constructor(metaDataInterface: MetaDataInterface) {
    this.name = metaDataInterface.name;
    this.status = metaDataInterface.status;
    this.message = metaDataInterface.message;
    this.source = metaDataInterface.source;
    this.quantity = metaDataInterface.quantity;
    this.dateTime = metaDataInterface.dateTime;
    const dateSplit: string[] = (this.dateTime.split('.'))[0].split(' ');
    if (dateSplit && dateSplit[1]) {
      this.time = dateSplit[1];
    } else {
      this.time = null;
    }
  }

  public getDate(): Date {
    return new Date(this.dateTime);
  }
}
